
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/pickup/ram-1500",
      function () {
        return require("private-next-pages/rims/pickup/ram-1500.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/pickup/ram-1500"])
      });
    }
  